import {
  HeaderMenu,
  MenuItem,
  MenuSeparator,
  MenuUserData,
  Header as DSHeader,
  HeaderMenuTrigger,
} from "@globalgiving/components"
import { FC, ReactNode } from "react"
import { config } from "~/config"

import HeaderHomeLink from "./HeaderHomeLink"

type HeaderProps = {
  logout: VoidFunction
  userEmail?: string
  userFullName?: string
  burgerButton?: ReactNode
  isAdmin?: boolean
}

export const Header: FC<HeaderProps> = ({ isAdmin, logout, userEmail, userFullName, burgerButton }) => {
  const triggerButton =
    !!userEmail && !!userFullName ? (
      <HeaderMenuTrigger>
        <MenuUserData className="!py-0 pr-4" email={userEmail} username={userFullName} />
      </HeaderMenuTrigger>
    ) : undefined

  return (
    <DSHeader
      burgerButton={burgerButton}
      logo={<HeaderHomeLink />}
      menu={
        <HeaderMenu trigger={triggerButton}>
          {userEmail && userFullName && (
            <>
              <MenuUserData email={userEmail} username={userFullName} />
              <MenuSeparator />
            </>
          )}
          {isAdmin && (
            <MenuItem asChild>
              <a
                className="body-base px-6 py-2 font-bold text-primary-green-dark data-[highlighted]:bg-secondary-navy-lightest1"
                href={`${config.globalGivingBaseUrl}/dy/v2/admin/gg/menu.html`}
                rel="noreferrer"
                target="_blank"
              >
                Admin
              </a>
            </MenuItem>
          )}
          <MenuItem asChild>
            <a
              className="body-base px-6 py-2 font-bold text-primary-green-dark data-[highlighted]:bg-secondary-navy-lightest1"
              href={`${config.globalGivingBaseUrl}/dy/v2/pe/dashboard/`}
              rel="noreferrer"
              target="_blank"
            >
              My Dashboard
            </a>
          </MenuItem>
          <MenuSeparator />
          <MenuItem title="Logout" onClick={logout} />
        </HeaderMenu>
      }
    />
  )
}
